// Single source of truth for the public site origin.
//
// Used anywhere an absolute strongerbot.com URL is built: SEO canonicals,
// hreflang, JSON-LD @id/url/item, OpenGraph/Twitter urls, share links, the
// embeddable widget src. One edit here if the domain ever changes — same
// rationale as data/modelStats.js (model count), data/plans.js (prices) and
// data/contact.js (email). Never re-hardcode "https://strongerbot.com".
export const SITE_URL = "https://strongerbot.com";

// Public Google Play listing (app LIVE in Production since 2026-11-03).
// Built from the Android Play applicationId `com.strongerbot.app` (the iOS
// bundle + code namespace stay `com.strongbot.app`; the Play id is the neuf
// one — see CLAUDE.md §E). Single-source so the store link / structured-data
// install URL never drifts. Add the App Store URL here once iOS goes live.
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.strongerbot.app";
